export default function(app){
	const context=import.meta.globEager("./*.js");
	Object.keys(context).forEach(key=>{
		if(key.includes('index')) return;
		context[key].default(app);
	})
}